import cn from 'classnames'
// Components
import styles from './Radio.module.scss'

export default function Radio ({
  options,
  value,
  onChange,
  showError,
  errorMessage,
  inline,
  inlineBox,
  bold,
  isMultiple: _isMultiple
}) {
  const isMultiple = _isMultiple && Array.isArray(value) // Multiple
  return (
    <div className={cn({
      [styles.container]: true,
      [styles.inline]: inline,
      [styles.inlineBox]: inlineBox,
      [styles.hasErrorMessage]: !!errorMessage
    })}
    >
      {options.map((option, i) =>
        <div
          key={i}
          className={cn({
            [styles.option]: true,
            [styles.three]: options.length === 3,
            [styles.active]: value === option.value,
            [styles.bold]: bold,
            [styles.warning]: !!showError
          })}
          onClick={() => onChange(option)}
          onKeyDown={(e) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault()
              onChange(option)
            }
          }}
        >
          <div className={cn({
            [styles.checkbox]: true,
            [styles.active]: value === option.value
          })}
          />

          {(isMultiple && value.length
            ? value?.map((o) => o.label).join(', ')
            : option.label)}
        </div>
      )}

      {showError && !!errorMessage && (
        <div className={styles.error}>
          <div className={styles.icon} />
          <div className={styles.message}>{errorMessage}</div>
        </div>)}
    </div>
  )
}
